import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EachInfoContainer } from '../shared/container'
import { InfoExam } from '../shared/text-styled'
import * as S from './styled'
import { getLinkCompatibleWithUrl } from '../../utils/getLinksCompatibleWithUrl'

const Description = ({
  exam,
  titleSubAccordion,
  listLinks,
  linkDasaEduca,
  listLinksExamToDasaEduca,
  textLinkDasaeduca,
  textLinkToBlog,
  urlLocation
}) => {
  const [linkCompatibleWithUrlDasaEduca, setLinkCompatibleWithUrlDasaEduca] = useState('')
  const [linkToBlog, setLinkToBlog] = useState(null)

  useEffect(() => {
    if (!urlLocation || !listLinks?.linksSite || !listLinks?.linksBlog) return

    const linkCompatibleWithUrl = getLinkCompatibleWithUrl(listLinks.linksSite, urlLocation)

    setLinkCompatibleWithUrlDasaEduca(
      getLinkCompatibleWithUrl(listLinksExamToDasaEduca.linksExamsDasaEduca, urlLocation)
    )

    const index = linkCompatibleWithUrl ? listLinks.linksSite.indexOf(linkCompatibleWithUrl) : -1

    if (index !== -1) {
      setLinkToBlog(listLinks.linksBlog[index])
    } else {
      setLinkToBlog(null)
    }
  }, [urlLocation, listLinks, listLinksExamToDasaEduca.linksExamsDasaEduca])

  return (
    <EachInfoContainer noBorder>
      <InfoExam>
        {exam.informativeProduct.descricao}
        {(linkToBlog || linkCompatibleWithUrlDasaEduca) && (
          <S.ContentLinksInSingleExam>
            {linkToBlog && (
              <S.ContentLinkToBlog>
                <S.LinkToDasaEducaAndBlog href={linkToBlog ?? '#'} target="_blank">
                  {textLinkToBlog}
                </S.LinkToDasaEducaAndBlog>
              </S.ContentLinkToBlog>
            )}
            {linkCompatibleWithUrlDasaEduca && (
              <S.ContentLinkToDasaEduca>
                <S.LinkToDasaEducaAndBlog href={linkDasaEduca ?? '#'} target="_blank">
                  {textLinkDasaeduca}
                </S.LinkToDasaEducaAndBlog>
              </S.ContentLinkToDasaEduca>
            )}
          </S.ContentLinksInSingleExam>
        )}
      </InfoExam>

      {exam.informativeProduct.objetivo && (
        <Fragment>
          <S.ExamSummaryTitle>{titleSubAccordion}</S.ExamSummaryTitle>
          <InfoExam>{exam.informativeProduct.objetivo}</InfoExam>
        </Fragment>
      )}
    </EachInfoContainer>
  )
}

Description.propTypes = {
  exam: PropTypes.object.isRequired,
}

export default Description
